import { useCallback } from 'react';
import type { RecordSourceSelectorProxy } from 'relay-runtime';
/**
 * Commits a update to the Relay store with the updated column width (i.e. field set preferences)
 * @param connectionId ID of the `JiraIssueSearchFieldSetConnection` record
 */
export const useColumnWidthUpdater = (connectionId: string) => {
	return useCallback(
		(store: RecordSourceSelectorProxy, columnId: string, width: number | undefined) => {
			const connection = store.get(connectionId);

			const fieldSetEdges = connection?.getLinkedRecords('edges') ?? [];

			const fieldSetEdge = fieldSetEdges.find((edge) => {
				const fieldSetId = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
				return columnId === fieldSetId;
			});

			if (!fieldSetEdge) {
				return;
			}

			const fieldSetNode = fieldSetEdge.getLinkedRecord('node');

			if (!fieldSetNode) {
				return;
			}

			if (width == null) {
				fieldSetNode.setValue(null, 'fieldSetPreferences');
				return;
			}

			const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord(
				'fieldSetPreferences',
				'JiraFieldSetPreferences',
			);

			fieldSetPreferences.setValue(width, 'width');
		},
		[connectionId],
	);
};
